
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import moment from 'moment/moment'
import axios from '@/plugins/axios'
import MenuReservationItem from '@/model/MenuReservationItem'
import { CurrentUser } from '@/model/CurrentUser'
import { USER_LOGGED_IN } from '@/store/getter-types'
import _ from 'lodash'
import SummaryMonthOrder from "@/model/SummaryMonthOrder";
import i18n from "@/plugins/i18n";
import RatingDialog from "@/components/dashboard/RatingDialog.vue";
import {usePiniaStore} from "@/store/piniaStore";
import {CustomerResponse} from "@/types/service-response";
import {RatingModel} from "@/model/RatingModel";


interface MonthSummaryReport {
    code: string,
    summary: {
      active: number,
      canceled: number,
      delivered: number,
      totalAmount: number,
    }
}

@Component({
  components: {
    RatingDialog
  }
})
export default class MyOrderPage extends Vue {

  $refs!: {
    dateMenu: Vue & {
      save(date: string): void,
    },
  }

  private fetchInProgress: boolean = false
  private monthOrderList: MenuReservationItem[] = []
  private selectedMonth: string | null = ''
  private dateMenu: boolean = false
  private itemData: SummaryMonthOrder[] = [];
  private monthOrderReport: MonthSummaryReport[] = []
  private tab: number = 0
  private snackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private ratingValue: number | null = null
  private showDetailLastOrderClick: boolean = false
  private lastReservationDetailData: any[] = []
  private lastReservationNumber: number[] | null = []
  private piniaStore: any = usePiniaStore()
  private date: string = ''
  private boarderId: any | null = null
  private ratingDataList: RatingModel[] = []
  private ratingValueList: any[] = []
  private selectedOffer: any | null = null
  private showRatingLastOrder: boolean = false
  private ratingDeliveryTimeData: number | null= null

  isOfferDelivered (item:any): boolean {
    if(item.status.name === 'delivered') {
      return true
    } else {
      return false
    }

  }


  get getIcon () {
    if (this.ratingValue === 1) {
      return 'fas fa-grimace'
    } else if (this.ratingValue === 2) {
      return 'fas fa-frown-open'
    } else if (this.ratingValue === 3) {
      return 'fas fa-smile'
    } else if (this.ratingValue === 4) {
      return 'fas fa-grin-hearts'
    }
  }

  getRatingValue(item: any):number| null {
    let foundItem: any | undefined = this.ratingDataList.find((i:RatingModel) => i.offerReservations.includes(`/api/food-ordering/offer-reservation/${item.id}`))
    return foundItem ? foundItem.value : null
  }

  onShowRatingDialogClick (item: any) {
    this.selectedOffer = item
    this.showDetailLastOrderClick = true
  }

  setOpacity (value:any):any {
    if(value) {
      this.ratingValue = value !== null ? value : null;
    }
    return this.ratingValue

  }

  get getReservationData():any {
    let data:any[] = []
    this.lastReservationDetailData!.forEach((item:any) => {
      item.forEach((i:any) => {
        data.push(i)
      })

    })
    return data
  }

  get currentUser(): any {
    return this.$store.getters[USER_LOGGED_IN]
  }

  get getCardClass (): string {
    let width: string = ''
    if(this.$vuetify.breakpoint.mdAndUp){
      width = '600px'
    } else {
      width = ''
    }
    return width
  }

  get userLoggedIn(): CurrentUser{
    return this.$store.getters[USER_LOGGED_IN]
  }

  get getMonth(): string {
     return this.selectedMonth ? moment(this.selectedMonth).locale('sk').format('MMMM YYYY').toLocaleUpperCase() : moment().locale('sk').format('MMMM YYYY').toLocaleUpperCase()
  }

  getDate(item: string): string {
    return moment(item).locale('sk').format('D.M. dddd')
  }

  getStatusColor(item: SummaryMonthOrder): string {
    const statusName: string = item.status.name;
    if (statusName === 'canceled') {
      return 'error';
    } else if (statusName === 'delivered') {
      return 'success';
    }
    return 'primary'
  }

  getTitle(item: SummaryMonthOrder): string {
    const statusName: string = item.status.name;
    if (statusName === 'canceled') {
      return  i18n.t('myOrderPage.canceled').toString()
    } else if (statusName === 'delivered') {
      return  i18n.t('myOrderPage.delivered').toString()
    } else {
      return i18n.t('myOrderPage.active').toString()
    }

  }

  closeRatingDialog(): void{
    this.showDetailLastOrderClick = false
    this.fetchOfferRatigList()
  }

  refreshData (): void {
    this.showDetailLastOrderClick = false
    this.fetchOfferRatigList()
  }

  onMonthChange (item: string) {
    this.selectedMonth = item
    this.fetchData()
  }

  onNextButtonClick (): void {
    this.selectedMonth = moment(this.selectedMonth, 'YYYY-MM').add(1,'month').format('YYYY-MM')
    this.fetchData()
  }

  onPrevButtonClick (): void {
    this.selectedMonth = moment(this.selectedMonth, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
    this.fetchData()
  }

  async fetchData(): Promise<void> {
    const start_date = moment(this.selectedMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD')
    const end_date = moment(this.selectedMonth, 'YYYY-MM').startOf('month').format('YYYY-MM-DD')
    const boarder = this.userLoggedIn.boarderList[0].id
    try {
       this.fetchInProgress = true
       const response = await axios.get('/api/food-ordering/offer-reservation?date[before]=' + start_date + '&date[after]=' + end_date + '&boarder.id=' + boarder)
       this.monthOrderList = response.data
      this.lastReservationNumber = []
       this.monthOrderList.forEach((item:any) => {
          this.lastReservationNumber!.push(item.id)
          this.boarderId = item.boarder.id
        })
        if(this.lastReservationNumber !== null && this.monthOrderList && this.monthOrderList.length > 0) {
          await this.fetchOfferRatigList()
        }
       this.itemData = this.processItemData(this.monthOrderList)

       this.monthOrderReport = this.processSummaryData(this.monthOrderList)
    } catch (e) {
      this.snackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
      this.fetchInProgress = false
    }
  }

  processItemData(orders: MenuReservationItem[]): SummaryMonthOrder[]
  {
    return _(orders)
        .groupBy('date') // Zoskupenie podľa dátumu
        .map((dateGroup, date) => {
          const groupedOffers = _(dateGroup)
              .flatMap('reservedOffers')
              .groupBy(offer => `${offer.dailyMenuOffer.referenceFoodItem.id}`) // Kľúč pre zoskupenie podľa ID jedla
              .map((offerGroup, key) => {
                const firstOffer = _.head(offerGroup);
                const reservationIds = dateGroup.map(item => item.id); // Získanie všetkých ID rezervácií
                return {
                  dailyMenuOffer: firstOffer.dailyMenuOffer,
                  amount: _.sumBy(offerGroup, 'amount'), // Sčítanie amountov
                  reservationIds: reservationIds
                };
              })
              .value();

          return {
            date: date,
            reservedOffers: groupedOffers,
            status: dateGroup[0].status, // Predpokladáme rovnaký status pre všetky objednávky v skupine
            boarderNote: dateGroup[0].boarderNote,
            id: dateGroup[0].id
          };
        })
        .value()
  }

  processSummaryData(orders: MenuReservationItem[]): MonthSummaryReport[] {
    return _(orders)
        .flatMap(order =>
            order.reservedOffers.map(offer => ({
              ...offer,
              status: order.status.name // Pridanie statusu k ponuke
            }))
        ) // Sploštiť reservedOffers a pridať status
        .groupBy('dailyMenuOffer.menuGroupSlot.code') // Zoskupenie podľa kódu slotu
        .map((offers, code) => {
          // Objekt pre ukladanie sumárnych množstiev pre každý status
          const statusSummary: any = {
            active: 0,
            canceled: 0,
            delivered: 0,
            totalAmount: 0
          };

          // Prechádzať cez ponuky a sčítať amounty podľa statusu
          offers.forEach(offer => {
            const status = offer.status;
            if (statusSummary.hasOwnProperty(status)) {
              statusSummary[status] += offer.amount
              statusSummary.totalAmount += offer.amount
            }
          });

          return {
            code: code,
            summary: statusSummary
          };
        })
        .value()
  }

  async fetchOfferRatigList(): Promise<void> {
    let reservationId: any[] = []
    if(this.lastReservationNumber !== null) {
      this.lastReservationNumber.forEach((item:any) => {
        reservationId.push(item)
      })
    }
    const payload: any =  {
      boarderId: this.boarderId,
      id: reservationId
    }
    try {
      const response:any  = await this.piniaStore.fetchOfferRating(payload)
      this.ratingDataList = response
      this.ratingDataList.forEach((item:RatingModel) => {
        this.ratingValue = item.value
      })
      this.monthOrderList.forEach((item:any) => {
        this.lastReservationNumber!.push(item.id)
      })
    } catch (e) {
    }
  }

  async fetchCustomer(): Promise<void> {
    let payload: any = this.currentUser.boarderList[0].customer.id
    try {
      const response = await this.piniaStore.fetchCustomerQrConfiguration(payload)
      this.showRatingLastOrder = response.configuration.allow_rating_last_order || false
      this.ratingDeliveryTimeData = response.configuration.last_order_rating_delivery_time_delta
    } catch (e) {
    } finally {
    }
  }

  mounted () {
    this.fetchCustomer()
    this.selectedMonth = moment().format('YYYY-MM')
    this.fetchData()
  }
}
